import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SignPdfService } from '../../sign-pdf.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent implements OnInit {

  constructor(private signPdfService: SignPdfService) { }

  ngOnInit(): void {
  }

  toggleSideNav() {
    this.signPdfService.setShowNav(true); 
  }

}
